import React from "react";

import { TEXT_DEFAULT_MAX_LENGTH } from "config/constants";
import { Typography } from "new-components/typography/Typography";

interface TextRecognitionDetailSettingsProps {
  characterLimit?: number;
}

export function TextRecognitionDetailSettings({ characterLimit }: TextRecognitionDetailSettingsProps) {
  return (
    <>
      <Typography mt={1} textTransform="uppercase" fontWeight="bold" className="text-neutral-700">
        Answer Options:
      </Typography>
      <Typography>
        Text recognition character limit: {characterLimit || TEXT_DEFAULT_MAX_LENGTH} characters.
      </Typography>
    </>
  );
}
